import { BaseMapConfig } from '../../../app/config/model/basemap-config.model';

export const BASE_MAP_CONFIG: BaseMapConfig = {
  basemaps: [
    {
      title: 'JSON_CONFIG.BASE_MAP.AV_FARBIG',
      thumbnailUrl: 'assets/images/av_farbig.png',

      layers: [
        {
          fkLayer: 'av_farbig',
        },
      ],
    },
    {
      title: 'JSON_CONFIG.BASE_MAP.LK_FARBIG',
      thumbnailUrl: 'assets/images/lk.jpg',
      layers: [
        {
          fkLayer: 'landeskarten',
        },
      ],
    },
    {
      title: 'JSON_CONFIG.BASE_MAP.LUFTBILDER',
      thumbnailUrl: 'assets/images/ortho.jpg',

      layers: [
        {
          fkLayer: 'luftbilder',
        },
      ],
    },
    {
      title: 'JSON_CONFIG.BASE_MAP.TRAFIMAGE',
      thumbnailUrl: 'assets/images/trafi.png',
      layers: [
        {
          fkLayer: 'trafi_netz',
        },
      ],
    },
    {
      title: 'JSON_CONFIG.BASE_MAP.KEINE',
      thumbnailUrl: 'assets/images/none.jpg',
      defaultBaseMap: true,
      layers: [
        {
          fkLayer: 'none',
        },
      ],
    },
  ],
};
